// @flow

import * as React from "react";

import { Comment } from "buba-components";
import { type BankHints as BankHintsType } from "../../data/types/bankHints";
import styles from "./BankHintsWrapper.scss";

type BankHintsProps = {
  bankHints: BankHintsType
};

const BankHints = ({ bankHints }: BankHintsProps) =>
  bankHints.length ? (
    bankHints.map<React.Node>(({ author: { firstName, lastName }, content, createdAt, id }) => (
      <div className={styles.hintContainer} key={id}>
        <Comment
          author={`${firstName} ${lastName}`}
          content={() => content}
          postDate={new Date(createdAt)}
        />
      </div>
    ))
  ) : (
    <p>Aktuell sind keine Hinweise zu dieser Anfrage vorhanden.</p>
  );

export default BankHints;
